import { render } from "./BackArrowIcon.vue?vue&type=template&id=c8f2d200"
import script from "./BackArrowIcon.vue?vue&type=script&lang=js"
export * from "./BackArrowIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__